export const PROMOTION_CAMPAIGN_ENABLED = true;

export interface PromotionCampaignLink {
  label: string;
  href: string;
  accent: 'boy' | 'girl';
}

export const promotionCampaignLinks: PromotionCampaignLink[] = [
  { label: 'Meninos', href: '/catalogo?gender=1&promo=1', accent: 'boy' },
  { label: 'Meninas', href: '/catalogo?gender=2&promo=1', accent: 'girl' },
];

export function getCampaignCatalogHref(): string {
  return PROMOTION_CAMPAIGN_ENABLED ? '/catalogo?promo=1' : '/catalogo';
}
